import React, { useEffect, useRef } from "react"
import { graphql } from "gatsby"
import debounce from "lodash.debounce"

import Layout from "../components/layout"
import SEO from "../components/seo"

import TopSection from "../components/topSection"
import { FeaturedVideo, LiveVideo } from "../components/featuredVideo"
import Programme from "../components/programme"
import About from "../components/about"

import Laureates from "../components/laureates"
import Performers from "../components/performers"
import Articles from "../components/articles"

interface IndexQuery {
  data: {
    sanitySiteSettings: {
      pageTitle: string
      headline: string
      ogImageUrl?: string
      isLive: string
    }
    sanityVideoLinks: {
      liveVideoLink: string
      placeholderVideoLink: string
    }
  }
}

const IndexPage = ({
  data: { sanitySiteSettings, sanityVideoLinks },
}: IndexQuery) => {
  const { pageTitle, headline, isLive, ogImageUrl } = sanitySiteSettings

  const { liveVideoLink, placeholderVideoLink } = sanityVideoLinks

  const circleRef = useRef<HTMLDivElement>()

  const setCircleWidth = () => {
    const circleHeight = circleRef.current.offsetHeight
    circleRef.current.style.width = `${circleHeight}px`
  }

  useEffect(() => {
    if (!circleRef.current) return
    setCircleWidth()

    const debounceCircleWidth = debounce(setCircleWidth, 200)
    window.addEventListener("resize", debounceCircleWidth)

    return () => {
      window.removeEventListener("resize", debounceCircleWidth)
    }
  }, [])

  return (
    <Layout>
      <SEO title={pageTitle} ogImageUrl={ogImageUrl} />

      <TopSection headline={headline} isLive={isLive} />
      {isLive ? (
        <>
          <LiveVideo videoUrl={liveVideoLink} />
          <Programme />
        </>
      ) : (
        <FeaturedVideo videoUrl={placeholderVideoLink} />
      )}
      <About />
      <Laureates />

      <section className="teaser-section">
        <div ref={circleRef} className="circle"></div>
        <Performers />
        <Articles />
      </section>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    sanitySiteSettings {
      isLive
      pageTitle
      headline
      ogImageUrl
    }
    sanityVideoLinks {
      liveVideoLink
      placeholderVideoLink
    }
  }
`
